import {
    SitemapSettings,
    SitemapSettingsDescription,
    SitemapSettingsTitle,
    SiteMapNodeTypes,
    convertSitemapsToSitemapNodes,
    SitemapRootNode,
    getSitemapMapOrderValue,
} from "@iventis/sitemaps";
import { sectionalMargin, styled } from "@iventis/styles";
import React from "react";

import { NodeServices } from "@iventis/tree-browser";
import { mappingApi } from "@iventis/api/src/api";
import { Sitemap } from "@iventis/domain-model/model/sitemap";
import { convertStringDatesToDates, useFunctionality } from "@iventis/utilities";
import { toast } from "@iventis/toasts/src/toast";
import { NoAccessComponent } from "@iventis/permissions/src/upgrade-limit-overlay";

const rootSitemapNodeId = "root-sitemap-node";

const sitemapServices: NodeServices<SitemapRootNode> = {
    getTree: async () => {
        const { data: sitemaps } = await mappingApi.get<Sitemap[]>("/sitemaps");

        const sortedSitemaps = sitemaps.sort((a, b) => getSitemapMapOrderValue(b.mapOrder) - getSitemapMapOrderValue(a.mapOrder));

        convertStringDatesToDates(
            sortedSitemaps.flatMap((s) => s.versions),
            "date"
        );

        // Convert sitemaps into a tree browser node implementation of sitemaps
        const nodeData = convertSitemapsToSitemapNodes(sortedSitemaps, rootSitemapNodeId);

        // Wrap all the sitemaps around a blank root node
        return {
            id: rootSitemapNodeId,
            sourceId: rootSitemapNodeId,
            name: undefined,
            type: SiteMapNodeTypes.Root,
            childNodes: nodeData,
            childCount: nodeData.length,
        } as SitemapRootNode;
    },
    // Currently for our site map there is no editing sitemaps and we only get every sitemap, no way to get individual sitemaps
    addNode: async () => null,
    updateNode: async () => null,
    deleteNodes: async () => null,
    getNode: async () => null,
    moveNodes: async () => null,
    copyNodes: async () => null,
    getParents: async () => null,
};

export const SitemapSettingsPage = () => {
    const functionality = useFunctionality();

    if (functionality.siteMaps) {
        return <SitemapSettings toast={toast} services={sitemapServices} />;
    }

    return (
        <Container>
            <div className="header">
                <SitemapSettingsTitle />
                <SitemapSettingsDescription />
            </div>
            <div className="no-access">
                <NoAccessComponent upgradeType="siteMaps" />
            </div>
        </Container>
    );
};

const Container = styled.div`
    width: 100%;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    .header {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin: ${sectionalMargin};
    }
    .no-access {
        flex-grow: 1;
        display: flex;
        align-items: center;
    }
`;
